/* Eight Saints Dawn page behavior. Scoped and reinitialized on Theme Editor section reload. */
(() => {
  if (customElements.get('es-eye-advertorial')) return;
  class EightSaintsPage extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      const connection = this._abort;
      this._cleanups = [];
      queueMicrotask(() => {
        if (!this.isConnected || connection.signal.aborted) return;
        const root = this;
        const listen = (target, type, handler, options = {}) => {
          target.addEventListener(type, handler, { ...options, signal: connection.signal });
          if (type === 'pagehide') this._cleanups.push(handler);
        };
root.querySelectorAll('[data-comparison]').forEach(root=>{const range=root.querySelector('.comparison-range');const update=()=>{root.style.setProperty('--position',range.value+'%');range.setAttribute('aria-valuetext',range.value+'% before image visible')};listen(range,'input',update);update()});
const sticky=root.querySelector('[data-sticky-cta]');const finalOffer=root.querySelector('.final-offer');const updateSticky=()=>{const offer=finalOffer.getBoundingClientRect();sticky.classList.toggle('is-active',window.scrollY>620&&!(offer.top<window.innerHeight&&offer.bottom>0))};listen(window,'scroll',updateSticky,{passive:true});updateSticky();

root.querySelectorAll('[data-serum-video]').forEach(root=>{
  const stage=root.querySelector('.serum-video-stage');
  const poster=root.querySelector('[data-video-poster]');
  const video=root.querySelector('video');
  const playButton=root.querySelector('.serum-video-play');
  const error=root.querySelector('.serum-video-error');
  const showPoster=()=>{
    const restoreFocus=document.activeElement===video;
    video.pause();
    video.hidden=true;
    stage.classList.remove('is-playing');
    poster.removeAttribute('aria-hidden');
    playButton.hidden=false;
    if(restoreFocus) playButton.focus({preventScroll:true});
  };
  const showError=()=>{showPoster();error.hidden=false;};
  playButton.hidden=false;
  listen(playButton,'click',()=>{
    error.hidden=true;
    if(!video.getAttribute('src')||video.error) video.src=video.dataset.src;
    if(video.ended) video.currentTime=0;
    video.hidden=false;
    playButton.hidden=true;
    poster.setAttribute('aria-hidden','true');
    stage.classList.add('is-playing');
    video.focus({preventScroll:true});
    const playback=video.play();
    if(playback) playback.catch(showError);
  });
  listen(video,'error',showError);
  listen(video,'ended',showPoster);
});

      });
    }
    disconnectedCallback() {
      this._abort?.abort();
      this._cleanups?.forEach(cleanup => cleanup());
      this.querySelectorAll('video').forEach(video => video.pause());
      this._abort = null;
    }
  }
  customElements.define('es-eye-advertorial', EightSaintsPage);
})();
